/**
 * Collapse-text
 */
import config from './config'
import lightbox from './lightbox'

let init = false

const collapsetext = {
  state: {
    isActive: false
  },
  activate: function () {
    if (config.DEVMODE) {
      console.log('active: collapsetext')
    }
    // Не проводить повторную инициализацию
    if (init) return

    // Проверка критерия дальнейшего запуска
    const querySelector = 'fieldset.collapse-text-fieldset'
    const collapseFieldsets = document.querySelectorAll(querySelector)
    // Если объектов нет, то ничего не делать
    if (!collapseFieldsets.length) {
      if (config.DEVMODE) {
        console.log('collapse-text: no elements')
      }
      return
    }

    // Инициализация
    this.initialize(collapseFieldsets)
  },
  initialize (collapseFieldsets) {
    collapseFieldsets.forEach(fieldset => {
      const legend = fieldset.querySelector('legend')
      const text = fieldset.querySelector('.collapse-text-text')

      legend.addEventListener('click', () => {
        // fieldset.classList.toggle('collapsed-text-fieldset')
        fieldset.classList.toggle('collapsed')
        // text.classList.toggle('collapsed-text')
      })
    })
    init = true
    this.state.isActive = true
  }
}
export default collapsetext
